/**
 * @ngInject
 */

var cookie = {
    controller : cookieCtrl,
    transclude : true,
    template : '<div ng-transclude></div>'
};

function cookieCtrl($scope, $element, $localStorage) {
	var ctrl = this;

	function onInit() {
		ctrl.storage = $localStorage;
	}
	this.close = function close() {
		console.log("hello");
		ctrl.storage.cookieAccepted = true;
	};

	ctrl.$onInit = onInit;

}